import React, { FC, ReactNode } from 'react'
import { IntlProvider } from 'react-intl'
import fr from '../translations/fr'

interface IntlManagerProps {
	children: ReactNode
}

/**
 * Manager pour Intl
 */
const IntlManager: FC<IntlManagerProps> = ({ children }) => (
	<IntlProvider messages={fr} locale="fr" defaultLocale="fr">
		{children}
	</IntlProvider>
)

export default IntlManager